import {
  SEARCH_COLLECTION_REQUEST_START,
  SET_COLLECTION_DATA,
  SET_COLLECTION_ERROR,
  CLEAR_COLLECTION_DATA
} from 'shared/constants/actionTypes';

const initialState = {
  isRequesting: false,
  list: null,
  error: null
};

const collection = function (state = initialState, action) {
  switch (action.type) {
    case SEARCH_COLLECTION_REQUEST_START:
      console.log('SEARCH_COLLECTION_REQUEST_START', action);
      return {
        ...state,
        isRequesting: true,
        error: null
      };

    case SET_COLLECTION_DATA:
      console.log('SET_COLLECTION_DATA', action);
      return {
        ...state,
        isRequesting: false,
        list: action.payload
      };

    case SET_COLLECTION_ERROR:
      console.log('SET_COLLECTION_ERROR', action);
      return {
        ...state,
        isRequesting: false,
        list: null,
        error: action.payload
      };

    case CLEAR_COLLECTION_DATA:
      return {
        ...state,
        list: null,
        error: null
      };

    default:
      return state;
  }
};

export default collection;
